import { v4 } from 'uuid';

export const generateImageName = (name: string) => {
  const newId = v4();
  const ext = '.' + name.split('.').pop();

  return newId + ext;
};
